<template>
  <div class="full-page">
    <div class="w-full">
      <div class="flex full-content">
        <div>
          <the-navbar></the-navbar>
        </div>
        <div
          class="right-content"
          :class="IsExpandSibar ? 'right-content' : 'right-content-min'"
        >
          <the-header></the-header>
          <the-content class="the-content" ref="content"></the-content>
        </div>
      </div>
      <div class="full-footer flex items-center">
        <the-footer></the-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Page",
  created() {
    const me = this;
    if (me.$route.path == "/") {
      me.$router.push("/dashboard");
    }
  },
  computed: {
    ...mapGetters(["IsExpandSibar"]),
  },
};
</script>

<style lang="scss" scoped>
.full-page {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: "Roboto", sans-serif, Segoe UI, Helvetica Neue, Arial,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol !important;
}

.full-content {
  height: calc(100vh - 40px);
}
.the-content {
  height: calc(100% - 100px);
  overflow: auto;
}

.full-footer {
  height: 40px;
}
.right-content {
  width: calc(100% - 250px);
}

.right-content-min {
  width: calc(100% - 60px);
}
@import url("@/assets/contents/scss/layout/page.scss");
</style>
